import { render } from "./QuestionsListPage.vue?vue&type=template&id=7f3845e7&ts=true"
import script from "./QuestionsListPage.vue?vue&type=script&lang=ts"
export * from "./QuestionsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__